import React from 'react';
import { Grid, Row } from "react-bootstrap";
import { Card } from 'components/Card/Card.jsx';
import Cookies from 'universal-cookie';
import cookieManagement from '../utilities/Cookie';
const cookies = new Cookies();
let logoName = cookies.get('clientSubDomain') == undefined ? cookieManagement.setClientSubDomainToCookie() : cookies.get('clientSubDomain');

const Wallet = props => {
    const WalletCards = ({ logoName, walletData }) => {
        return (<Grid fluid>
            <Row>
                <Card style={{ fontSize: '12px' }}
                    title="eSeal"
                    title2="POC"
                    content={
                        <div>
                            <div className="row">
                                <div className="col-md-6 col-md-offset-3">
                                <form>
                                    <p className="h4 text-center mb-4">Eseal Inspect</p>
                                    <label htmlFor="defaultFormLoginEmailEx" className="grey-text">Product Id</label>
                                    <p>9641</p>
                                    <br />
                                    <label htmlFor="defaultFormLoginPasswordEx" className="grey-text">Quantity</label>
                                    <p>73</p>
                                    <label htmlFor="defaultFormLoginPasswordEx" className="grey-text">Eseal ID</label>
                                    <p>4487978187835608</p>
                                    <label htmlFor="defaultFormLoginPasswordEx" className="grey-text">Batch Number</label>
                                    <p>H025R2S4RI19289</p>
                                    <label htmlFor="defaultFormLoginPasswordEx" className="grey-text">Location name</label>
                                    <p>SPVC-III</p>
                                    <label htmlFor="defaultFormLoginPasswordEx" className="grey-text">Plant Code</label>
                                    <p>1300</p>
                                    <label htmlFor="defaultFormLoginPasswordEx" className="grey-text">UOM</label>
                                    <p>CO</p>
                                    <label htmlFor="defaultFormLoginPasswordEx" className="grey-text">Mfg Date</label>
                                    <p>2021-06-21</p>
                                    <label htmlFor="defaultFormLoginPasswordEx" className="grey-text">Material code</label>
                                    <p>216010272</p>
                                    <label htmlFor="defaultFormLoginPasswordEx" className="grey-text">PO Number</label>
                                    <p>131000005118</p>
                                    <label htmlFor="defaultFormLoginPasswordEx" className="grey-text">Operator Name</label>
                                    <p>SRIHARI</p>
                                    <label htmlFor="defaultFormLoginPasswordEx" className="grey-text">Machine Name</label>
                                    <p>Coiling Machine - 1</p>
                                    <label htmlFor="defaultFormLoginPasswordEx" className="grey-text">Shift</label>
                                    <p>Shift=A</p>
                                    <label htmlFor="defaultFormLoginPasswordEx" className="grey-text">Trace Status</label>
                                    <p>PO Packing</p>
                                    <label htmlFor="defaultFormLoginPasswordEx" className="grey-text">Source Location</label>
                                    <p>Plant</p>


                                    <div className="text-center mt-4">
                                    
                                    </div>
                                </form>
                                </div>
                            </div>
                        </div>
                    }
                >
                </Card>
            </Row>
        </Grid>);
    };

    return (
            <div className="content">
                <WalletCards
                    logoName={logoName}
                    walletData={"walletVal"}
                />
            </div>
    );
}

export default Wallet;
